import type { FC } from 'react';

export const Lamp: FC = () => {
	return (
		<svg
			width="92"
			height="96"
			viewBox="0 0 92 96"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M81.5322 0.0851288H10.4679C5.17651 0.0851288 0.886963 3.62574 0.886963 7.9933V87.177C0.886963 91.5445 5.17651 95.0851 10.4679 95.0851H81.5322C86.8236 95.0851 91.1131 91.5445 91.1131 87.177V7.9933C91.1131 3.62574 86.8236 0.0851288 81.5322 0.0851288Z"
				fill="#DCE3F9"
			/>
			<path
				d="M34.5525 64.6655V69.0972C34.5525 69.6495 35.0002 70.0921 35.5525 70.0921H55.1408C55.6931 70.0921 56.1408 69.6457 56.1408 69.0934V64.6655C56.1408 59.3947 61.9199 56.1663 64.0447 45.7099C66.1696 35.2535 61.7504 28.5398 57.0752 24.6293C52.4 20.7188 41.3514 19.7431 34.5525 24.6293C27.7535 29.5155 25.8826 38.0593 26.8175 45.7099C27.7524 53.3606 34.5525 58.9697 34.5525 64.6655Z"
				fill="white"
				stroke="#1C308B"
			/>
			<path
				d="M31.8291 37.9268C32.2779 32.8401 35.7189 28.2023 40.6559 27.1551"
				stroke="#1C308B"
				stroke-linecap="round"
			/>
			<path
				d="M36.7661 74.8796L54.4197 72.4859"
				stroke="#1C308B"
				stroke-linecap="round"
			/>
			<path
				d="M67.9458 33.7728L75.7693 32.4969"
				stroke="#1C308B"
				stroke-linecap="round"
			/>
			<path
				d="M67.9458 48.144L75.7693 50.221"
				stroke="#1C308B"
				stroke-linecap="round"
			/>
			<path
				d="M62.3575 21.4787L69.0634 15.7322"
				stroke="#1C308B"
				stroke-linecap="round"
			/>
			<path
				d="M45.5928 15.7322V9.02631"
				stroke="#1C308B"
				stroke-linecap="round"
			/>
			<path
				d="M28.8281 21.3204L23.2399 15.7322"
				stroke="#1C308B"
				stroke-linecap="round"
			/>
			<path
				d="M22.1223 32.4969L15.4164 31.3792"
				stroke="#1C308B"
				stroke-linecap="round"
			/>
			<path
				d="M22.1223 48.144L14.2987 49.2616"
				stroke="#1C308B"
				stroke-linecap="round"
			/>
			<path
				d="M36.7661 77.2733L54.4197 74.8796"
				stroke="#1C308B"
				stroke-linecap="round"
			/>
			<path
				d="M36.7661 79.6667L54.4197 77.273"
				stroke="#1C308B"
				stroke-linecap="round"
			/>
			<path
				d="M49.4627 81.7611H42.0323C41.4507 81.7611 40.9871 82.2577 41.0655 82.8339C41.537 86.2986 42.9466 87.147 45.8792 87.147C48.8278 87.147 50.0281 86.4892 50.4377 82.8266C50.5019 82.2523 50.0405 81.7611 49.4627 81.7611Z"
				fill="white"
				stroke="#1C308B"
			/>
		</svg>
	);
};
